import { render, staticRenderFns } from "./CurrencySelect.vue?vue&type=template&id=a65715dc&"
import script from "./CurrencySelect.vue?vue&type=script&lang=js&"
export * from "./CurrencySelect.vue?vue&type=script&lang=js&"
import style0 from "./CurrencySelect.vue?vue&type=style&index=0&id=a65715dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports